import {DiceSettingEnum} from '@colonist/types'
import {PlayerEnums} from '../../../../shared/GameEnums'
import {StorageWrapper} from '../StorageWrapper'
import {SocketLobbySend} from '../socket/SocketLobbySend'

export class UIRoomSettingsController {
    static initRoomSettingFromLocalStorage(): void {
        const diceSetting = UIRoomSettingsController.getLocalStorageDiceSettings()
        if(diceSetting != undefined) SocketLobbySend.clickedRoomSettingUpdateDiceSetting(DiceSettingEnum[diceSetting])

        const friendlyRobberActive = UIRoomSettingsController.getLocalStorageFriendlyRobberSettings()
        if(friendlyRobberActive != undefined) SocketLobbySend.clickedRoomSettingChangeFriendlyRobber(friendlyRobberActive)

        const gameSpeedSetting = UIRoomSettingsController.getLocalStorageGameSpeedSettings()
        if(gameSpeedSetting != undefined) {
            const gameSpeedString = PlayerEnums.GameSpeedSettings[gameSpeedSetting] as keyof typeof PlayerEnums.GameSpeedSettings
            SocketLobbySend.clickedRoomSettingChangeGameSpeed(gameSpeedString)
        }

        const botSpeedSetting = UIRoomSettingsController.getLocalStorageBotSpeedSettings()
        if(botSpeedSetting != undefined) {
            const botSpeedString = PlayerEnums.BotSpeedSettings[botSpeedSetting] as keyof typeof PlayerEnums.BotSpeedSettings
            SocketLobbySend.clickedRoomSettingChangeBotSpeed(botSpeedString)
        }
    }

    private static getLocalStorageDiceSettings(): DiceSettingEnum | undefined {
        const diceSetting = StorageWrapper.getRoomDiceSetting()
        if(diceSetting == null) return undefined
        return diceSetting
    }

    private static getLocalStorageFriendlyRobberSettings(): boolean | undefined {
        const friendlyRobberActive = StorageWrapper.getRoomFriendlyRobberActiveSetting()
        if(friendlyRobberActive == null) return undefined
        return friendlyRobberActive
    }

    private static getLocalStorageGameSpeedSettings(): PlayerEnums.GameSpeedSettings | undefined {
        const gameSpeedSetting = StorageWrapper.getRoomGameSpeedSetting()
        if(gameSpeedSetting == null) return undefined
        return gameSpeedSetting
    }

    private static getLocalStorageBotSpeedSettings(): PlayerEnums.BotSpeedSettings | undefined {
        const botSpeedSetting = StorageWrapper.getRoomBotSpeedSetting()
        if(botSpeedSetting == null) return undefined
        return botSpeedSetting
    }
}
